import { render, staticRenderFns } from "./CoTwoProductionLogistic.vue?vue&type=template&id=eb884e2c&scoped=true&"
import script from "./CoTwoProductionLogistic.vue?vue&type=script&lang=js&"
export * from "./CoTwoProductionLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb884e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb884e2c')) {
      api.createRecord('eb884e2c', component.options)
    } else {
      api.reload('eb884e2c', component.options)
    }
    module.hot.accept("./CoTwoProductionLogistic.vue?vue&type=template&id=eb884e2c&scoped=true&", function () {
      api.rerender('eb884e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoProductionLogistic.vue"
export default component.exports